import {StatePrice} from "@/store/api/statePriceApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface StatePriceList {
    statePriceList: StatePrice[],
}

const initialState: StatePriceList = {
    statePriceList: [],
}

const statePriceSlice = createSlice({
    name: "statePrice",
    initialState,
    reducers: {
        setStatePrices: (state, action: PayloadAction<StatePrice[]>) => {
            state.statePriceList = action.payload;
        },
        clearStatePrices: (state) => {
            state.statePriceList = [];
        }
    }
})

export const {setStatePrices, clearStatePrices} = statePriceSlice.actions;
export default statePriceSlice.reducer;